import { render, staticRenderFns } from "./HelpReleveCompteComponent.vue?vue&type=template&id=2b731fb6"
import script from "./HelpReleveCompteComponent.vue?vue&type=script&lang=js"
export * from "./HelpReleveCompteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports